export enum MessageType {
  Success = 1,
  Info = 2,
  Warning = 3,
  Error = 4
}
